import Breakpoints from 'breakpoints-js/dist/breakpoints.es';
/**
 * Init breakpoints
 */
export const TiResponsiveBreakpoints = {
    phone: {
        min: 0,
        max: 767
    },
    tablet: {
        min: 768,
        max: 1239
    },
    desktop: {
        min: 1240,
        max: Number.POSITIVE_INFINITY
    }
};
new Breakpoints(TiResponsiveBreakpoints);
/**
 * Enum definition for viewport sizes.
 */
export var TiResponsiveViewport;
(function (TiResponsiveViewport) {
    TiResponsiveViewport["phone"] = "phone";
    TiResponsiveViewport["tablet"] = "tablet";
    TiResponsiveViewport["desktop"] = "desktop";
})(TiResponsiveViewport || (TiResponsiveViewport = {}));
/**
 * The `@TiResponsiveTracker` decorator.
 * When applied, the component will listen for media changes and update its
 * `viewportSize` state/property.
 */
export function TiResponsiveHandler() {
    function handleBreakpointsChange(viewport) {
        this.viewportSize = viewport;
    }
    return (target, _propertyKey) => {
        const { componentWillLoad, disconnectedCallback } = target;
        // hijack the componentDidLoad  to track the component
        target.componentWillLoad = function () {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const _self = this;
            // fetch and update viewport size on load
            (handleBreakpointsChange.bind(_self, Breakpoints.current().name))();
            // call the original componentWillLoad
            if (componentWillLoad) {
                componentWillLoad.call(this);
            }
            // Add listeners for all sizes provided
            Breakpoints.on('change', function () {
                (handleBreakpointsChange.bind(_self, this.current.name))();
            });
        };
        target.disconnectedCallback = function () {
            // Remove listeners for all sizes provided
            Breakpoints.off('change');
            // call the original disconnectedCallback
            if (disconnectedCallback) {
                disconnectedCallback.call(this);
            }
        };
    };
}
